import React from 'react';
import { Modal, Box } from '@mui/material';
import { IDefaultModal } from './ModalInterfaces';
import { close } from '../../assets/images';
import styled from 'styled-components';

const DabaduModal = styled(Modal)`
  &.MuiModal-root {
    margin: 15px;
  }
  &.blur-backdrop {
    .MuiModal-backdrop {
      backdrop-filter: blur(10px);
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  & .MuiBox-root {
    border: none;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    background-color: ${(props) => props.theme.colors.whiteColor};
  }
  & .modal-close {
    color: red;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

export const DefaultModal: React.FC<IDefaultModal> = ({ 
  open, 
  handleClose, 
  childern, 
  customClass,
  rootClass
}) => {
  const style = {};

  return (
    <>
      <DabaduModal
        open={open}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        className={rootClass}
      >
        <Box sx={style} className={customClass}>
          <a href='#' onClick={handleClose} className='modal-close'>
            <img src={close} alt='Close' className='img-fluid' />
          </a>
          <>{childern}</>
        </Box>
      </DabaduModal>
    </>
  );
};
